"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postDistributorFlashOrderFile = exports.POST_FLASH_ORDER_MAX_FILES = void 0;
var post_distributor_flash_order_file_1 = require("./post-distributor-flash-order-file");
Object.defineProperty(exports, "POST_FLASH_ORDER_MAX_FILES", { enumerable: true, get: function () { return post_distributor_flash_order_file_1.POST_FLASH_ORDER_MAX_FILES; } });
Object.defineProperty(exports, "postDistributorFlashOrderFile", { enumerable: true, get: function () { return post_distributor_flash_order_file_1.postDistributorFlashOrderFile; } });
